module.exports = __webpack_public_path__ + "assets/img/22_1316_big.5cdc8903.jpg";